var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "strategy-features-section"
  }, [_c('div', {
    staticClass: "main-container"
  }, _vm._l(_vm.fields.field_one.value.boxes, function (feature) {
    return _c('feature4', {
      key: feature.title,
      attrs: {
        "feature": feature
      }
    });
  }), 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }